import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kv_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("kv_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    t: translations[lang] || translations.fr,
    langs: LANGS,
    pick: (obj) => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] || obj.fr || obj.en || Object.values(obj)[0] || "";
    },
  }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
